import {
  TIERS_SOUS_TYPE_BAILLEUR_PRIVE, TIERS_SOUS_TYPE_BAILLEUR_CONCESSION,
  TIERS_SOUS_TYPE_BAILLEUR_PRO, TIERS_SOUS_TYPE_BAILLEUR_ADMINISTRATION_ET_ASSIMILEE,
} from '@/configuration/tiers/tiersConf';

export default function genererCritereRechercheBailleur() {
  return {
    auto: null,
    archive: false,
    email: null,
    telephone: null,
    compteComptable: null,
    motifsBlocagesId: [],
    blocageReglement: null,
    villes: [],
    tiers: [],
    sousType: [
      TIERS_SOUS_TYPE_BAILLEUR_PRO,
      TIERS_SOUS_TYPE_BAILLEUR_CONCESSION,
      TIERS_SOUS_TYPE_BAILLEUR_PRIVE,
      TIERS_SOUS_TYPE_BAILLEUR_ADMINISTRATION_ET_ASSIMILEE,
    ],
    depts: [],
  };
}
